function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.2265 10.1587L34 0.158691L39.7735 10.1587L35 10.1587L35 59.6587L33 59.6587L33 10.1587L28.2265 10.1587Z",
  fill: "#9F9A98"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33 59.6588L33 44.6588C33 36.9268 26.732 30.6588 19 30.6588L10 30.6588L10 35.4323L-2.52368e-07 29.6588L10 23.8853L10 28.6588L19 28.6588C27.8365 28.6588 35 35.8222 35 44.6587L35 59.6588L33 59.6588Z",
  fill: "#9F9A98"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28 64.6587C28 61.6857 30.1623 59.2177 33 58.7416L33 44.6588C33 35.8222 40.1635 28.6588 49 28.6588H59V23.8853L69 29.6588L59 35.4323V30.6588L49 30.6588C41.268 30.6588 35 36.9268 35 44.6588L35 58.7416C37.8377 59.2177 40 61.6857 40 64.6587C40 67.9724 37.3137 70.6587 34 70.6587C30.6863 70.6587 28 67.9724 28 64.6587ZM34 68.6587C36.2091 68.6587 38 66.8678 38 64.6587C38 62.4496 36.2091 60.6587 34 60.6587C31.7909 60.6587 30 62.4496 30 64.6587C30 66.8678 31.7909 68.6587 34 68.6587ZM35 64.6587C35 65.211 34.5523 65.6587 34 65.6587C33.4477 65.6587 33 65.211 33 64.6587C33 64.1064 33.4477 63.6587 34 63.6587C34.5523 63.6587 35 64.1064 35 64.6587ZM37 64.6587C37 66.3155 35.6569 67.6587 34 67.6587C32.3431 67.6587 31 66.3155 31 64.6587C31 63.0018 32.3431 61.6587 34 61.6587C35.6569 61.6587 37 63.0018 37 64.6587Z",
  fill: "#3C3C3B"
});

var SvgFeatureOne2 = function SvgFeatureOne2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 69,
    height: 71,
    viewBox: "0 0 69 71",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFeatureOne2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FeatureOne-2.71f3d131.svg";
export { ForwardRef as ReactComponent };